import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'xpo-app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  ngOnInit(): void {
  }
}
